import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FileUploader } from 'ng2-file-upload';

import { ProductsService } from '../../shared/services/products.service';
import { AccountService } from '../../shared/services/account.service';
import { UtilsService } from '../../shared/services/utils.service';
import { ContactService } from '../../shared/services/contact.service';
import { MetadatasService } from '../../shared/services/metadatas.service';
import { AppService } from '../../shared/services/app.service';

import { HTTPClientService } from '../../shared/services/httpclient.service';
import {TranslateService} from '@ngx-translate/core';
import { ProdTagService } from '../../shared/services/prodtag.service';
import { LanguageService } from '../../shared/services/language.service';
import { CustomProductsService } from '../../shared/services/custom-products.service'
import { SubscriptionsService } from '../../shared/services/subscriptions.service'
import { ClientOrderService } from '../../shared/services/clientorder.service'
import { LocalstorageService } from '../../shared/services/localstorage.service';

import {Location} from '@angular/common';

declare var $: any; import {isBrowser} from '../../shared/thirdparty/isBrowser'
declare var Swal:any;


import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-product-page',
    templateUrl: './product-page.component.html',
    styleUrls: ['./product-page.component.css']
})
export class ProductPageComponent implements OnInit, OnDestroy {




    public productid = -1;

    public iframeShow:any = false;

    public product: any = {readme: "", description: ""};
    public url : any;

    public contactInputs = {"name":"", "email":"", "societe":"", "tel":""}
    public contactError:any = [false, false, false, false, ""]

    public partnerLogoStatus = 0;

    public pdfGenerated = false;

    public canSetInterest = true;

    public interestMessage = "Nous sommes désormais informés de votre intérêt pour cet exercice"

    public months = {
        "00" : "",
        "01" : this.translate.instant("Janvier"),
        "02" : this.translate.instant("Février"),
        "03" : this.translate.instant("Mars"),
        "04" : this.translate.instant("Avril"),
        "05" : this.translate.instant("Mai"),
        "06" : this.translate.instant("Juin"),
        "07" : this.translate.instant("Juillet"),
        "08" : this.translate.instant("Aout"),
        "09" : this.translate.instant("Septembre"),
        "10" : this.translate.instant("Octobre"),
        "11" : this.translate.instant("Novembre"),
        "12" : this.translate.instant("Décembre"),
    }

    public productTags = [];

    public productSwicth2d = {
        'showVideo' : false,
        'showImg1' : false,
        'showImg2' : false,
        'showImg3' : false,
        'showImg4' : false
    }

    public videoHear = true;

    public mail;

    public config: Object = {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 30,
        autoplay: 10000
    };

    public config2: Object = {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 4,
        paginationClickable: false,
        spaceBetween: 30,
        autoplay: 10000
    };

    public prices = {
        init : 0,
        total : 0
    }

    public pcHeadsets = [
        { value : 'vivepro', name : "HTC Vive Pro" }
    ]
    public pcHeadsetSelected = "vivepro"

    public autonomeHeadsets = [
        { value : 'focusplus', name : "HTC Vive Focus Plus" },
        { value : 'occulusQuest', name : "Occulus Quest"}
    ]
    public autonomeHeadsetSelected = "focusplus"

    public carouselShow = 0

    public fadedTextLoop = null

    public loopTexts = [this.translate.instant("Safety"), this.translate.instant("Environment"), this.translate.instant("Health"), this.translate.instant("Social responsibilities")]
    public loopTextIndex = 0

    isGroup = false

    constructor(
        public productService: ProductsService,
        public accountService: AccountService,
        public contactService: ContactService,
        public utilsService: UtilsService,
        public sanitizer: DomSanitizer,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public httpclient: HTTPClientService,
        public appService:AppService,
        public translate : TranslateService,
        public prodTagService: ProdTagService,
        public language : LanguageService,
        public cref : ChangeDetectorRef,
        public customProductsService : CustomProductsService,
        public subscriptionsService : SubscriptionsService,
        public clientOrderService : ClientOrderService,
        public localStorage : LocalstorageService,
        public metadatas : MetadatasService,
        private _location: Location
    ) {}

    ngOnInit() {

        if(this.fadedTextLoop){
            if(isBrowser()) clearInterval(this.fadedTextLoop)
        }
        if(isBrowser()) this.fadedTextLoop = setInterval(()=>{
            if($('#fadedText')){
                $('#fadedText').css('opacity', 0)
                setTimeout(()=>{
                    if(this.loopTextIndex+1>=this.loopTexts.length){
                        this.loopTextIndex=0
                    }
                    else{
                        this.loopTextIndex++
                    }
                    $('#fadedText').css('opacity', 1)
                }, 400);
            }
        }, 2000)

        //window.addEventListener('scroll', this.onScroll, true);
        // subscribe to router event
        this.activatedRoute.params.subscribe((params: Params) => {
            console.log(params)
            var param = params["name"] || params["pathctx2"]
            if(param){
                var productId = this.productid = params['name'].split("-")[0]
                if(productId.slice(0,1) === "g"){
                    this.isGroup = true
                    productId = productId.slice(1)
                }
                this.productid = productId
            }

            this.loadProduct();
        });

    }

    ngOnDestroy(){
        if(isBrowser()) clearInterval(this.fadedTextLoop)
    }

    popupHeadset(){
        Swal.fire({
            icon : 'info',
            html: this.translate.instant("Immersive Factory ne revend pas les casques VR veuillez consulter")+`
            <a href="https://immersivefactory.com/partners" target="_blank">`+this.translate.instant("nos revendeurs")+`</a>`
        })
    }

    loadProduct() {
        this.productService.getProductById(this.productid, this.isGroup).then(res => {
            this.product = res
            console.log(this.product)

            this.product.prodtags = this.product.prodtags.filter(e => e['id'])
            this.productShow(this.product);
            if(this.product.companyGroupId){
                this.router.navigate(this.language.navigateAccordingToLang(['/']))
            }
            if(this.accountService.isLogged()){
                this.productService.getInterestedUsers(this.productid)
                .then((result)=>{
                    if(result && result.filter(user => user.id == this.accountService.userInfos.id).length>0){
                        this.canSetInterest = false
                    }
                })
            }

            if(!this.product['publicAccountObj']){
                this.product['publicAccountObj']=  {mail:""}
            }


            this.product["srcPreview"] = this.productService.getProductImage(this.product["preview"])
            this.product["srcScreenshot1"] = this.productService.getProductImage(this.product["screenshot1"])
            this.product["srcScreenshot2"] = this.productService.getProductImage(this.product["screenshot2"])
            this.product["srcScreenshot3"] = this.productService.getProductImage(this.product["screenshot3"])

            this.metadatas.setMetaTag('title', this.product["name"]+" "+this.translate.instant('By').toLowerCase()+" Immersive Factory")
            // this.metadatas.setMetaTag('keywords', ((this.product["keywords"]) ? this.product["keywords"].join(',') : ''))
            this.metadatas.setMetaTag('description', this.product["subtitle"])
            this.metadatas.setMetaTag('image', this.product["srcPreview"])
            this.metadatas.setMetaTag('og:image:width', 712)
            this.metadatas.setMetaTag('og:image:height', 416)
            this.metadatas.setMetaTag('og:image:type', ((this.product["srcPreview"].includes('.png')) ? "image/png" : "image/jpeg" ))

            if (!this.product["video"]) {
                this.carouselShow=1
            }

            if(!this.utilsService.isEmpty(this.product['partnerLogo'])){
                this.productService.testPartnerLogo(this.product['partnerLogo'])
                .then( res => {
                    if(res == false){
                        this.partnerLogoStatus=0
                        this.product['partnerLogo'] = null
                    }
                    else{
                        this.partnerLogoStatus=1
                        this.product['partnerLogo'] = this.productService.getpartnerLogo(this.product['partnerLogo'])+'?unique=' + new Date().getTime();
                    }
                })
            }

            this.productService.getHTML(this.product['htmlBody']).then(res => {
                this.product['content'] = res;
            });

            if(this.product["video"]){
                this.product["video"] = decodeURIComponent(this.product["video"])
                var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                var match = this.product["video"].match(regExp);
                this.product['yt_id'] = (match&&match[7].length==11)? match[7] : false;
            }

            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.product["video"]);
        });
    }

    onDownload() {
        //
    }

    sendInterest(){
        this.interestMessage = this.translate.instant("Nous sommes désormais informés de votre intérêt pour cet exercice")
        if(!this.accountService.isLogged()){
            this.translate.get('Envoi d\'un email').subscribe((res: string) => {
                if(isBrowser()) $(".send-interest-button-"+this.product.id).html('<i class="material-icons">more_horiz</i>'+res);
            });
            if(isBrowser()) $(".send-interest-button-"+this.product.id).addClass("disabled");
            var mail = this.mail;
            if(this.utilsService.validMail(mail)){
                var productId = this.product.id;
                this.contactService.sendInterestAnonymous(mail,productId)
                .then((rep)=>{
                    if(isBrowser()) $("#modal-interest").modal("hide")
                    this.translate.get('M\'informer de la disponibilité').subscribe((res: string) => {
                        if(isBrowser()) $(".send-interest-button-"+this.product.id).html('<i class="material-icons">notifications_none</i>'+res);
                    });
                    if(rep.status == 'error'){
                        if(rep.message == "already interest"){
                            this.interestMessage = "Vous avez déjà manifesté votre intérêt pour cet exercice"
                            this.canSetInterest = false
                        }
                        else if(rep.message == "bad mail"){
                            this.interestMessage = "L'adresse email saisie n'est pas correcte"
                            this.canSetInterest = false
                        }
                        else{
                            this.interestMessage = "Une erreur est survenue, veuillez réessayer plus tard"
                        }
                    }
                    else{
                        this.canSetInterest = false
                        this.iframeShow = true;
                        this.translate.get('M\'informer de la disponibilité').subscribe((res: string) => {
                            if(isBrowser()) $(".send-interest-button-"+this.product.id).html('<i class="material-icons">notifications_none</i>'+res);
                        });
                    }
                    if(isBrowser()) $("#modal-interest-success").modal("show")

                })
            }
            else{
                this.translate.get('M\'informer de la disponibilité').subscribe((res: string) => {
                    if(isBrowser()) $(".send-interest-button-"+this.product.id).html('<i class="material-icons">notifications_none</i>'+res);
                });
                if(isBrowser()) $('#emailInput').val("");
                this.translate.get('Email incorrect').subscribe((res: string) => {
                    if(isBrowser()) $('#emailInput').attr("placeholder", res)
                });
            }
        }
        else{
            this.translate.get('Envoi d\'un email').subscribe((res: string) => {
                if(isBrowser()) $(".send-interest-button-"+this.product.id).html('<i class="material-icons">more_horiz</i>'+res);
                if(isBrowser()) $(".send-interest-button-"+this.product.id).addClass("disabled");
                if(isBrowser()) $(".send-interest-button-"+this.product.id).attr("disabled","disabled");
            });
            if(isBrowser()) $("#interest-button").addClass("disabled");
            var accountId = this.accountService.userInfos['id'];
            var productId = this.product.id;
            this.contactService.sendInterest(accountId, this.accountService.userInfos['mail'],productId)
            .then((rep)=>{
                if(rep.status == 'error'){
                    if(rep.message == "already interest"){
                        this.interestMessage = "Vous avez déjà manifesté votre intérêt pour cet exercice"
                        this.canSetInterest = false
                    }
                    else{
                        this.interestMessage = "Une erreur est survenue, veuillez réessayer plus tard"
                    }
                }
                else{
                    this.canSetInterest = false
                    this.iframeShow = true;
                    this.translate.get('M\'informer de la disponibilité').subscribe((res: string) => {
                        if(isBrowser()) $(".send-interest-button-"+this.product.id).html('<i class="material-icons">notifications_none</i>'+res);
                    });
                }
                if(isBrowser()) $("#modal-interest-success").modal("show");
            })
        }

    }


    iframeLoaded(){
        this.iframeShow = false;
    }


    loadImage(event){
        this.partnerLogoStatus = 2;
        var myReader:FileReader = new FileReader();
        let fileList: FileList = event.target.files;
        let file: File = fileList[0];
        myReader.onloadend = (e) => {
            this.product.partnerLogo = myReader.result;
            this.partnerLogoStatus = 3;
        }
        myReader.readAsDataURL(file);
    }

    selectAnotherHeadset(){
        if(this.autonomeHeadsetSelected == "occulusQuest"){
            Swal.fire({
                html : '<p class="mb-2">'+ this.translate.instant("Les formations et le casque Oculus for business ne seront disponibles qu'en 2020, pour plus d'informations, nous contacter")+"</p>",
                icon :'warning',
                confirmButtonText : this.translate.instant("Continuer")
            })
            .then(()=>{
                this.autonomeHeadsetSelected = "focusplus"
            })
        }
    }

    getDevice(){
        var device = this.productService.types.find(e => e.id == this.product.type)
        return ((device) ? device['name'] : '')
    }

    gifPreview(target, product){
        if(isBrowser()) product['timeoutGIF'] = setTimeout(() => {
            var previews = [
                product.screenshot1,
                product.screenshot2,
                product.screenshot3,
                product.preview
            ]
            var img= null
            if(isBrowser()) img = $('#'+target.id)
            img.css('height',img.css('height'))
            img.css('width',img.css('width'))
            img.attr('src',previews[0])
            var i=0;
            if(isBrowser()) product['PreviewGIF'] = setInterval(() => {
                if(i==3){i=0}
                else{i++}
                img.attr('src',previews[i])
            }, 750);
        },500)
    }

    resetPreview(target, product){
        if(isBrowser()) clearTimeout(product['timeoutGIF']);
        if(isBrowser()) clearInterval(product['PreviewGIF'])
        if(isBrowser()) $('#'+target.id).attr('src',product.preview)
    }

    productShow(product){
        if(product){
            this.productSwicth2d.showVideo = true;
        }else{
            this.productSwicth2d.showImg1 = true;
            this.videoHear = false;
        }
    }

    buyWorkshop(){
        this.localStorage.setItem('basket', JSON.stringify({
            items:[
                {type:'workshop', referenceId : this.product['id'], period:'annual'}
            ]
        }))
        this.router.navigate(this.language.navigateAccordingToLang(['/basket']))
    }

    buyCatalog(){
        this.localStorage.setItem('basket', JSON.stringify({
            items:[
                {type:'workshops'}
            ]
        }))
        this.router.navigate(this.language.navigateAccordingToLang(['/basket']))
    }

    buyCampus(){
        this.localStorage.setItem('basket', JSON.stringify({
            items:[
                {type:'campus'},
                {type:'users_subscription'}
            ]
        }))
        this.router.navigate(this.language.navigateAccordingToLang(['/basket']))
    }

    goBack() {
        this._location.back();
    }


}
